import { api } from "@/lib/api";
import type { PermitDetail, PermitEvent, PermitStep } from "@/lib/permitProcesses";

export interface AddressChangeCandidate {
  worker_id: string; worker_name: string; source_case_id: string | null; source_permit_id: string | null;
  source_process_id: string | null; old_address: string; target_on: string;
}
export interface AddressChangeStatus { candidate: AddressChangeCandidate | null; reasons: string[] }
export async function getAddressChangeStatus(workerId: string, signal?: AbortSignal) {
  return (await api.get<AddressChangeStatus>(`/radnici/${workerId}/dozvole/promjene-adrese/status`, { signal })).data;
}
export interface AddressChangeAttachment {
  id: string; code: string; name_hr: string; document_template_code: string | null;
  ready: boolean; dokument_id: string | null;
}
export interface PermitAddressChange {
  process: Omit<PermitDetail["process"], "process_type"> & { process_type: "change" };
  source_case_id: string | null; source_permit_id: string | null; source_process_id: string | null; case_number: string; worker_name: string;
  old_address: string; new_address: string; target_on: string; permit_expires_on?: string | null;
  steps: PermitStep[]; attachments: AddressChangeAttachment[]; events: PermitEvent[];
}
export interface AddressChangeTarget { id: string; address: string; available: number }
const root = "/dozvole/promjene-adrese";
export async function getAddressChangeCandidates(workerId?: string, signal?: AbortSignal) {
  return (await api.get<AddressChangeCandidate[]>(`${root}/kandidati`, { params: { worker_id: workerId }, signal })).data;
}
export async function getPermitAddressChanges(workerId?: string, signal?: AbortSignal) {
  return (await api.get<PermitAddressChange[]>(root, { params: { worker_id: workerId }, signal })).data;
}
export async function getAddressChangeTargets(signal?: AbortSignal) {
  return (await api.get<AddressChangeTarget[]>(`${root}/adrese`, { signal })).data;
}
export async function startAddressChange(workerId: string, source: Pick<AddressChangeCandidate, "source_case_id" | "source_permit_id">, targetAddressId: string) {
  return (await api.post<PermitAddressChange>(`/radnici/${workerId}/dozvole/promjene-adrese`, { source_case_id: source.source_case_id, source_permit_id: source.source_permit_id, target_address_id: targetAddressId })).data;
}
export async function getPermitAddressChange(id: string, signal?: AbortSignal) {
  return (await api.get<PermitAddressChange>(`${root}/${id}`, { signal })).data;
}
export async function saveAddressChangeAttachment(id: string, attachmentId: string, ready: boolean, dokumentId: string | null = null) {
  await api.put(`${root}/${id}/prilozi/${attachmentId}`, { ready, dokument_id: dokumentId });
}
export async function completeAddressChangeStep(id: string, code: string, data: { completed_on: string; note: string; confirm_full: boolean }) {
  await api.post(`${root}/${id}/koraci/${code}`, data);
}

export async function cancelAddressChange(id: string, reason: string) {
  await api.post(`${root}/${id}/otkazi`, { reason });
}
